<template>
  <div class="action">
    <template v-if="getUserType === 'observer'">
      <router-link
        v-for="(route, index) in observerRoutes"
        :key="index"
        :to="routeUrl(route)"
        v-bind:class="{ selected: routeSelected(route) }"
      >
        <el-badge :value="count[route.id]" :hidden="count[route.id] == 0">
          <span
            v-if="route.path === 'record' && hasFlaggedProblems"
            class="flag-icon"
          >
            <img :src="require(`./image/flag-border.svg`)" />
          </span>
          <img class="header-icon" :src="iconType(route.icon, route)" />
        </el-badge>
        <span :title="route.text">{{ route.text }}</span>
        <div class="shadow"></div>
      </router-link>
    </template>
    <template v-else>
      <router-link
        v-for="(route, index) in visibleRoutes"
        :key="index"
        :to="routeUrl(route)"
        v-bind:class="{ selected: routeSelected(route) }"
      >
        <span @click="addConsiderationActivity(route.path)" style="display:flex; flex-direction: column;">
          <el-badge :value="count[route.id]" :hidden="count[route.id] == 0">
            <span
              v-if="route.path === 'record' && hasFlaggedProblems"
              class="flag-icon"
              
            >
              <img :src="require(`./image/flag-border.svg`)" />
            </span>
            <img class="header-icon" :src="iconType(route.icon, route)" />
          </el-badge>
          <span :title="route.text">{{ route.text }}</span>
          <div class="shadow"></div>
        </span>
      </router-link>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex"
import isEmptyObj from '@/module/util/empty-object'


export default {
  name: "header-action",

  props: {
    recommendation: {
			type: Array,
			required: true
		},
    patientId: {
      type: String
    },
    routes: {
      type: Array,
      required: true,
    },
    url: {
      type: String,
      default: "/",
    },
    count: {
      type: Object,
      default: () => ({}),
    },
    hasRecords: {
      type: Boolean,
      default: false,
    },
    hasFlaggedProblems: {
      type: Boolean,
      default: false,
    },
    hasConsideration: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      observerHeaderActions: [
        "patient-overview",
        "patient-response",
        "patient-record",
      ],
    };
  },

  computed: {
    ...mapState(["routeName"]),
    observerRoutes() {
      return this.routes.filter((r) =>
        this.observerHeaderActions.includes(r.component.name)
      );
    },
    /**
     * Returns the visible routes based on user type.
     * The visible routes filtered for path `record` and `consideration`
     * are only shown if `hasRecords` and `hasConsideration` are true respectively.
     * @returns {Array} Filtered routes based on user type and conditions.
     */
    visibleRoutes() {
      return this.routes.filter((route) => {
        if (route.path === "record") {
          return this.hasRecords;
        } else if (route.path === "consideration") {
          return this.hasConsideration;
        }
        return true;
      });
    },
    ...mapGetters(["getUserType"]),
  },

  methods: {
    ...mapActions('provider', [
			'updatePatientRecommendationFeedback'
		]),
    routeUrl(route) {
      return (
        this.url +
        (this.url.charAt(this.url.length - 1) == "/" ? "" : "/") +
        route.path
        + (this.$route.fullPath.includes('?') ? ( '?' + this.$route.fullPath.split('?')[1]) : '')
      )
    },
    routeSelected(route) {
      var url = this.routeUrl(route);
      if (url.endsWith("/")) url = url.substring(0, url.length - 1);
      return this.routeName === url;
    },
    iconType(icon, route) {
      return this.routeSelected(route)
        ? require(`./image/${icon}-active.png`)
        : require(`./image/${icon}-inactive.png`);
    },
    addConsiderationActivity(routePath) {
      if (routePath === 'consideration') {
        const newRecommendation = this.recommendation;
        try {
          if(newRecommendation && newRecommendation.length > 0) {
            const meta = newRecommendation[0].meta || [];
            const isKeyHistory = meta.some(item => item.type === 'activity' && item.ref_id === 'key_history');
            if(!isKeyHistory) {
              const newMeta = [...meta, {
                type: 'activity',
                ref_id: 'key_history',
                time: Date.now()
              }];
              this.updatePatientRecommendationFeedback({
                provider: newRecommendation[0].provider_id,
                patient: this.patientId,
                recommendation: newRecommendation[0].id,
                feedback: {
                  ...(newRecommendation[0].feedback || {}),
                  meta: newMeta
                }
              });
            }
          }
        } catch (error) {
          console.error('Error updating recommendation meta:', error);
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./style/action.scss";
.flag-icon {
  position: absolute;
  top: 6px;
  left: 5px;
}
</style>
